function localstore() {
	if (Cookies("localstore") == null) { Cookies('localstore', 'NONE', { path: '/', domain: 'supermarchepa.com', expires: 365 });
		$("#parc-mark,#fort-mark,#samson-mark,#westbury-mark").addClass("none");
		$('#popup-store').click() }
	else if (Cookies("localstore") == "PARC") { $("#parc-mark,#fort-mark,#samson-mark,#westbury-mark").addClass("none");
		$("#parc-mark").removeClass("none");
		$("#flyer-holder").addClass("parc-flyer");
		document.title = 'Supermarché PA du Parc Weekly Flyer';
		$("#flyer-holder h1").html("PA du Parc Weekly Specials"); }
	else if (Cookies("localstore") == "FORT") { $("#parc-mark,#fort-mark,#samson-mark,#westbury-mark").addClass("none");
		$("#fort-mark").removeClass("none");
		$("#flyer-holder").addClass("fort-flyer");
		document.title = 'Supermarché PA du Fort Weekly Flyer';
		$("#flyer-holder h1").html("PA du Fort Weekly Specials"); }
	else if (Cookies("localstore") == "SAMSON") { $("#parc-mark,#fort-mark,#samson-mark,#westbury-mark").addClass("none");
		$("#samson-mark").removeClass("none");
		$("#flyer-holder").addClass("pa-samson");
		document.title = 'Supermarché PA Samson Weekly Flyer';
		$("#flyer-holder h1").html("PA Samson Weekly Specials"); }
	else if (Cookies("localstore") == "WESTBURY") { $("#parc-mark,#fort-mark,#samson-mark,#westbury-mark").addClass("none");
		$("#westbury-mark").removeClass("none");
		$("#flyer-holder").addClass("pa-westbury");
		document.title = 'Supermarché PA Westbury Weekly Flyer';
		$("#flyer-holder h1").html("PA Westbury Weekly Specials"); }
	else if (Cookies("localstore") == "NONE") { $("#parc-mark,#fort-mark,#samson-mark,#westbury-mark").addClass("none");
		$('#popup-store').click() } }

function setToParc() { Cookies('localstore', 'PARC', { path: '/', domain: 'supermarchepa.com', expires: 365 });
	$("#parc-mark,#fort-mark,#samson-mark,#westbury-mark").addClass("none");
	$("#parc-mark").removeClass("none");
	location.reload() }

function setToFort() { Cookies('localstore', 'FORT', { path: '/', domain: 'supermarchepa.com', expires: 365 });
	$("#parc-mark,#fort-mark,#samson-mark,#westbury-mark").addClass("none");
	$("#fort-mark").removeClass("none");
	location.reload() }

function setToSamson() { Cookies('localstore', 'SAMSON', { path: '/', domain: 'supermarchepa.com', expires: 365 });
	$("#parc-mark,#fort-mark,#samson-mark,#westbury-mark").addClass("none");
	$("#samson-mark").removeClass("none");
	location.reload() }
	
function setToWestbury() { Cookies('localstore', 'WESTBURY', { path: '/', domain: 'supermarchepa.com', expires: 365 });
$("#parc-mark,#fort-mark,#samson-mark,#westbury-mark").addClass("none");
$("#westbury-mark").removeClass("none");
location.reload() }
window.onload = localstore;